<script>
export let width;
</script>
<svg role="img" width="{width}" aria-label="tidyDOM" version="1.1" viewBox="0 0 925.23 232.34"
     xml:space="preserve"
     xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
        .st0 {
            fill: rgb(104, 117, 245);
        }

        .cc {
            fill: currentColor;
        }

        .st1 {
            fill: rgb(255, 255, 255);
        }

        .st2 {
            fill: rgb(104, 117, 245);
        }

    </style>
    <g transform="translate(-545.37,-883.83)">
        <path
              class="cc"
              d="m883.69 1035c-2.1 1.72-4.66 3.01-7.67 3.87s-6.19 1.29-9.54 1.29c-8.42 0-14.92-2.2-19.51-6.6s-6.89-10.81-6.89-19.22v-36.86h-12.63v-14.35h12.63v-17.5h17.93v17.5h20.52v14.35h-20.52v36.44c0 3.73 0.91 6.58 2.72 8.53 1.82 1.96 4.45 2.94 7.89 2.94 4.02 0 7.36-1.05 10.04-3.16z" />
        <path
              class="cc"
              d="m899.33 946.87c-2.2-2.06-3.3-4.61-3.3-7.68 0-3.06 1.1-5.62 3.3-7.67 2.2-2.06 4.92-3.09 8.18-3.09 3.25 0 5.98 0.98 8.18 2.94s3.3 4.43 3.3 7.39c0 3.16-1.08 5.81-3.23 7.96s-4.9 3.23-8.25 3.23c-3.26 0-5.98-1.03-8.18-3.08zm-0.86 15.7h17.93v76.61h-17.93z" />
        <path
              class="cc"
              d="m1015 932.73v106.45h-17.22v-9.9c-2.97 3.64-6.62 6.36-10.98 8.18-4.35 1.82-9.16 2.73-14.42 2.73-7.37 0-13.99-1.63-19.87-4.88s-10.5-7.87-13.85-13.84c-3.35-5.98-5.02-12.84-5.02-20.59s1.67-14.58 5.02-20.52c3.35-5.93 7.96-10.52 13.85-13.77 5.88-3.25 12.5-4.88 19.87-4.88 5.07 0 9.71 0.86 13.92 2.58s7.79 4.3 10.76 7.75v-39.31zm-28.83 89.17c3.44-1.96 6.17-4.76 8.18-8.39s3.01-7.84 3.01-12.62-1-8.99-3.01-12.62-4.73-6.43-8.18-8.39c-3.44-1.96-7.32-2.94-11.62-2.94s-8.18 0.98-11.62 2.94-6.17 4.76-8.18 8.39c-2.01 3.64-3.01 7.84-3.01 12.62s1 8.99 3.01 12.62c2.01 3.64 4.73 6.44 8.18 8.39 3.44 1.96 7.32 2.94 11.62 2.94s8.17-0.98 11.62-2.94z" />
        <path
              class="cc"
              d="m1110.2 962.57-35.87 82.78c-3.35 8.32-7.42 14.18-12.19 17.57-4.78 3.39-10.57 5.09-17.36 5.09-3.83 0-7.6-0.62-11.33-1.86s-6.79-2.97-9.18-5.16l7.17-13.2c1.72 1.63 3.75 2.92 6.1 3.87 2.34 0.95 4.71 1.43 7.1 1.43 3.16 0 5.76-0.81 7.82-2.44s3.95-4.35 5.67-8.18l1.29-3.01-33.43-76.9h18.65l24.1 56.67 24.25-56.67h17.21z" />
        <path class="st0"
              d="m1124.7 938.76h42.32c10.62 0 20.04 2.11 28.26 6.31 8.22 4.21 14.61 10.11 19.15 17.72 4.54 7.6 6.81 16.33 6.81 26.18s-2.27 18.58-6.81 26.18-10.93 13.51-19.15 17.72c-8.23 4.21-17.65 6.31-28.26 6.31h-42.32zm41.47 87.94c8.13 0 15.28-1.58 21.45-4.73 6.17-3.16 10.93-7.58 14.28-13.27s5.02-12.27 5.02-19.73-1.67-14.03-5.02-19.73c-3.35-5.69-8.1-10.11-14.28-13.27-6.17-3.16-13.32-4.73-21.45-4.73h-27.12v75.46z" />
        <path class="st0"
              d="m1261.2 1033.7c-8.13-4.45-14.51-10.59-19.15-18.44-4.64-7.84-6.96-16.59-6.96-26.25s2.32-18.41 6.96-26.25 11.02-13.99 19.15-18.44 17.26-6.67 27.4-6.67c10.04 0 19.13 2.22 27.26 6.67s14.49 10.57 19.08 18.37 6.89 16.57 6.89 26.33-2.3 18.53-6.89 26.33-10.95 13.92-19.08 18.37-17.22 6.67-27.26 6.67c-10.14-0.02-19.27-2.24-27.4-6.69zm47.27-11.11c5.88-3.35 10.52-7.96 13.92-13.85 3.39-5.88 5.09-12.46 5.09-19.73s-1.7-13.85-5.09-19.73c-3.4-5.88-8.04-10.5-13.92-13.85-5.88-3.34-12.51-5.02-19.87-5.02s-14.04 1.68-20.01 5.02c-5.98 3.35-10.67 7.96-14.06 13.85-3.4 5.88-5.09 12.46-5.09 19.73s1.7 13.85 5.09 19.73c3.4 5.88 8.08 10.5 14.06 13.85s12.65 5.02 20.01 5.02 13.99-1.68 19.87-5.02z" />
        <path class="st0"
              d="m1456.8 1039.2-0.14-73.17-36.3 60.97h-6.6l-36.3-60.54v72.74h-13.77v-100.43h11.76l41.89 70.59 41.32-70.59h11.76l0.14 100.43z" />
        <path class="st0"
              d="m741.94 1116.2h-160.8c-19.75 0-35.77-16.01-35.77-35.77v-160.8c0-19.75 16.01-35.77 35.77-35.77h160.8c19.75 0 35.77 16.01 35.77 35.77v160.8c0 19.76-16.02 35.77-35.77 35.77z" />
        <path class="st1"
              d="m581.26 970.06h-12.46v-45.27c0-9.67 7.86-17.53 17.53-17.53h45.27v12.46h-45.27c-2.79 0-5.07 2.27-5.07 5.07z" />
        <path class="st1"
              d="m736.75 1092.7h-45.27v-12.46h45.27c2.8 0 5.07-2.27 5.07-5.07v-45.27h12.46v45.27c0 9.67-7.86 17.53-17.53 17.53z" />
        <path class="st1"
              d="m631.6 1092.7h-45.27c-9.67 0-17.53-7.87-17.53-17.53v-45.27h12.46v45.27c0 2.8 2.27 5.07 5.07 5.07h45.27z" />
        <path class="st1"
              d="m754.28 970.06h-12.46v-45.27c0-2.79-2.27-5.07-5.07-5.07h-45.27v-12.46h45.27c9.67 0 17.53 7.86 17.53 17.53z" />
    </g>
</svg>
